export default "__VITE_ASSET__B11Zknip__"